
export default {
  name: 'PageEmbed',
  layout: 'embed',
  head() {
    const generalConfig = this.$store.state.base.meta.generalConfig
    const projectConfig = this.$store.state.base.meta.projectConfig
    return {
      title: `${generalConfig.baseTitle} - ${projectConfig.meta.title}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: projectConfig.meta.description
        }
      ],
      link: [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: generalConfig.favicon
        }
      ]
    }
  }
}
